import { render, staticRenderFns } from "./marginExtraction.vue?vue&type=template&id=2eff52d2&scoped=true&"
import script from "./marginExtraction.vue?vue&type=script&lang=js&"
export * from "./marginExtraction.vue?vue&type=script&lang=js&"
import style0 from "./marginExtraction.vue?vue&type=style&index=0&id=2eff52d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff52d2",
  null
  
)

export default component.exports